import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material'

const GraphicsPanel = ({ title, children, className = '', footer = null, empty = false, emptyLabel = 'Não disponível.', style, bodyStyle }) => {
	return (
		<section className={`scout-panel scout-panel--content scout-graphics-panel ${className}`.trim()} style={style}>
			<div className="scout-panel__heading scout-graphics-panel__heading">
				<h2>{title}</h2>
				<InfoOutlinedIcon />
			</div>
			<div className={empty ? 'scout-graphics-panel__body scout-graphics-panel__body--empty' : 'scout-graphics-panel__body'} style={bodyStyle}>
				{empty ? <div className="scout-graphics-empty-state">{emptyLabel}</div> : children}
			</div>
			{footer ? <div className="scout-graphics-panel__footer">{footer}</div> : null}
		</section>
	)
}

export default GraphicsPanel